export const getConsentItemTypeText = consentItem => consentItem.type;
